import {Link} from "react-router-dom";

export default function NotFound() {
  return (
    <>
    <div className="min-h-screen bg-white flex flex-col items-center pt-24 px-4">
      <p className="text-gray-500 text-lg mb-8">
        The requested URL was not found on our server.{" "}
        <Link
          to="/"
          className="text-blue-600 hover:underline font-medium"
        >
          Go to the homepage »
        </Link>
      </p>

      <div className="relative w-full max-w-4xl bg-primary px-10 py-14 flex items-center gap-10">
        <div className="text-white font-extrabold text-[96px] leading-none">
          404
          <div className="text-[28px] font-bold tracking-wide -mt-2">
            ERROR
          </div>
        </div>

        <div className="text-white text-2xl font-semibold leading-snug">
          Webpages? Where we're going, we don't need webpages.
        </div>

        <div className="absolute bottom-[-18px] right-20 w-0 h-0 border-l-[18px] border-l-transparent border-r-[18px] border-r-transparent border-t-[18px] border-t-primary" />
      </div>

    </div>
    </>
  );
}
